import { Box, AHText, AHTextFonts, EmployeeAvatar } from "arkh";
import React, { useMemo } from "react";
import { useFragment, graphql } from "react-relay";
import { EmployeeScheduleNameEmployeeNamePanel_employee$key } from "./__generated__/EmployeeScheduleNameEmployeeNamePanel_employee.graphql";

export const NamePanel = React.memo(NamePanelCmp);
function NamePanelCmp(props: {
  employee: EmployeeScheduleNameEmployeeNamePanel_employee$key;
  height: number;
}) {
  const employee = useFragment(
    graphql`
      fragment EmployeeScheduleNameEmployeeNamePanel_employee on Employee {
        name
        ...Avatar_employee
      }
    `,
    props.employee
  );

  const name = useMemo(() => {
    const parts = employee.name.split(" ");
    const firstName = parts[0];
    const lastName = parts.slice(1).join(" ");
    return `${firstName}\n${lastName}`.trim();
  }, [employee.name]);
  return (
    <Box
      style={{
        flexDirection: "row",
        height: props.height,
        borderRightWidth: 1,
        alignItems: "center",
      }}
      borderColor="border-primary"
    >
      <EmployeeAvatar employee={employee} size="small" />
      <AHText
        font={AHTextFonts.BOLD}
        numberOfLines={2}
        spaceLeft="small"
        type="detail"
        ellipsizeMode="tail"
        color="darkerText"
        spaceRight="xsmall"
        style={{
          overflow: "hidden",
          flex: 1,
        }}
      >
        {name}
      </AHText>
    </Box>
  );
}
